<template>
  <div>
    <multiselect
      v-model="valore"
      :options="options"
      :multiple="true"
      placeholder="Seleziona uno o più elementi"
      selectLabel="Premi invio per selezionare"
      valoreLabel	=	'Seleziona'
      deselectLabel	=	'Premi invio per rimuovere'
       @input="notify"
    >
      <span slot="noResult">{{ $t("message.not_found_search") }}</span>
      <span slot="noOptions">Non ci sono risultati disponibili</span>
    </multiselect>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
  components: {Multiselect},

  data() {
    return {
      valore: [],
      isLoading: true,
    };
  },

  props: ["selected", "options"],
  watch: {
    selected: function (v2, v1) {
      this.valore = v2 ? v2.split(",") : [];
    },
  },

  methods: {
    notify: function (value) {
      this.$emit("change", this.valore.join(","));
    }
  },
  mounted() {
    const self = this;
    self.valore = self.selected ? self.selected.split(",") : [];
  },
};
</script>

<style scoped>
</style>
